import { Link } from "react-router-dom";
import { testimonials, blogEntry } from "@/mocks/testimonials";

export default function TestimonialSection() {
  const textCards = testimonials.filter((t) => t.type === "text");
  const imageCard = testimonials.find((t) => t.type === "image");

  return (
    <section className="relative w-full py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-background-100">
      {/* Header */}
      <div className="text-center mb-12 md:mb-16">
        <div className="inline-flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded-lg bg-accent-200 flex items-center justify-center">
            <i className="ri-verified-badge-fill text-accent-700 text-lg"></i>
          </div>
          <span className="text-xs font-semibold text-accent-700 whitespace-nowrap">Avaliações Verificadas</span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
          O que dizem sobre a{" "}
          <span className="italic font-normal">CSSBuy Sheet</span>
        </h2>
      </div>

      {/* Testimonial Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-6">
        {/* Text Card 1 */}
        <div className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/50">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center flex-shrink-0">
              <span className="text-accent-700 text-sm font-bold">{textCards[0].avatar}</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{textCards[0].name}</p>
              <p className="text-xs text-foreground-500 whitespace-nowrap">{textCards[0].location}</p>
            </div>
          </div>
          <div className="text-accent-500 mb-3 text-lg">
            <i className="ri-double-quotes-l"></i>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-6">{textCards[0].text}</p>
        </div>

        {/* Text Card 2 */}
        <div className="bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/50">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
              <span className="text-secondary-700 text-sm font-bold">{textCards[1].avatar}</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{textCards[1].name}</p>
              <p className="text-xs text-foreground-500 whitespace-nowrap">{textCards[1].location}</p>
            </div>
          </div>
          <div className="text-accent-500 mb-3 text-lg">
            <i className="ri-double-quotes-l"></i>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-6">{textCards[1].text}</p>
        </div>

        {/* Image Card */}
        {imageCard && (
          <div className="relative rounded-2xl overflow-hidden h-[380px] md:h-full min-h-[320px] group">
            <img
              src={imageCard.image}
              alt={imageCard.name}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-6">
              <p className="text-background-50 text-sm font-semibold whitespace-nowrap">{imageCard.name}</p>
              <p className="text-background-50/70 text-xs whitespace-nowrap">{imageCard.location}</p>
            </div>
          </div>
        )}
      </div>

      {/* Second Row - Wide Card + Dual Small Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {/* Wide Card */}
        <div className="md:col-span-2 relative rounded-2xl overflow-hidden h-[280px] md:h-[320px] group">
          <img
            src="https://readdy.ai/api/search-image?query=Candid%20street%20photography%20of%20two%20friends%20in%20casual%20streetwear%20laughing%20while%20looking%20at%20a%20smartphone%20together%2C%20leaning%20against%20a%20warm%20terracotta%20colored%20wall%20in%20a%20sunny%20alley%2C%20golden%20hour%20backlight%2C%20genuine%20happy%20moment%2C%20editorial%20lifestyle%20photography%2C%20natural%20color%20palette&width=1200&height=600&seq=testimonial-v2-wide-01&orientation=landscape"
            alt="CSSBuy cliente feliz"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-accent-950/90 to-transparent p-6 md:p-8">
            <p className="text-background-50 text-sm font-semibold whitespace-nowrap">{textCards[2]?.name || "Ana Ferreira"}</p>
            <p className="text-background-50/70 text-xs mb-3 whitespace-nowrap">{textCards[2]?.location || "Porto, Portugal"}</p>
            <p className="text-background-50/85 text-sm leading-relaxed line-clamp-2">
              {textCards[2]?.text || "A melhor planilha CSSBuy que já usei! Atualização semanal faz toda diferença."}
            </p>
          </div>
        </div>

        {/* Dual Small Cards */}
        <div className="flex flex-col gap-5 md:gap-6">
          {/* Upper card - blog entry */}
          <Link
            to={`/artigo/${blogEntry.slug}`}
            className="flex-1 bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/50 cursor-pointer transition-all hover:border-accent-300 group"
          >
            <div className="flex items-start gap-3 h-full">
              <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 mt-0.5">
                <img
                  src={blogEntry.image}
                  alt={blogEntry.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col justify-between h-full">
                <div>
                  <span className="text-xs font-semibold text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    Artigo SEO
                  </span>
                  <p className="text-sm font-semibold text-foreground-900 mt-2 mb-1 leading-snug group-hover:text-accent-700 transition-colors">
                    {blogEntry.title}
                  </p>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {blogEntry.summary}
                  </p>
                </div>
                <span className="text-xs font-medium text-accent-600 mt-2 whitespace-nowrap">
                  Ler artigo completo →
                </span>
              </div>
            </div>
          </Link>

          {/* Lower card - testimonial */}
          <div className="flex-1 bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/50">
            <div className="text-accent-500 mb-2 text-lg">
              <i className="ri-double-quotes-l"></i>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-3">
              {textCards[3]?.text || "Depois de muito tempo procurando, achei essa planilha CSSBuy que realmente funciona."}
            </p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                <span className="text-secondary-700 text-xs font-bold">{textCards[3]?.avatar || "RL"}</span>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">{textCards[3]?.name || "Rafael Lima"}</p>
                <p className="text-xs text-foreground-500 whitespace-nowrap">{textCards[3]?.location || "Belo Horizonte"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}